import AbsComponent from "../../components/AbsComponent";
import {hasClass} from '../../common/Utils';

export default class AbsListItem extends AbsComponent{
    
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', it = {}){
        super(_name, _store, _actions, _router, _el);

        const watch = this.watch(this.store.getState, 'favDetail', this.isEqual);
        this.store.subscribe( watch( this.fav.bind(this) ) );

        this.itemId = it.id;
        this.isFavorite = it.favorite;
        this.favApi = ``;
        this.detailPrefix = ``;
    }
    
    makeItem(it = {}){}
    
    addEvents(){
        this.itemEl.on('click', (e)=>{
            if( hasClass(e.target, 'btn-favorite') ) return;
            this.router.goMultiParam({detail: this.detailPrefix + e.currentTarget.dataset.id});
        });

        this.itemEl.find('.btn-favorite').on('click', (e)=>{
            this.favCall(e.currentTarget.dataset.id, !this.isFavorite);
        });
    }

    favCall(_id, _isFav){
        console.log('????', _id, _isFav);
        const l10n = this.store.getState().config.l10n;

        axios( {
            method: this.isFavorite? 'DELETE': 'POST',
            url: this.favApi,
            withCredentials: true
        })
        .then( (_res) => {
            this.isFavorite = _isFav;
            this.itemEl.find('.btn-favorite').toggleClass('is-active', _isFav);
            /* 
            if (this.store.getState().favorite === 'true' && !_isFav) {
                this.router.goMultiParam({page: 1});
            }
             */

            ncrwd.toast({ 
                id: 'gif' + Math.random().toString(36).substr(2, 9),
                title: _isFav? l10n['common.favoritesAdded']: l10n['common.favoritesRemoved'], 
                usePrimaryBtn: (!_isFav && this.store.getState().favorite == 'true'),
                primaryBtnText: l10n['common.cancelAction'],
                useCancelBtn: false, site:'lw', autoClose: 4000, 
                didClose: (_result) => {
                    if (_result && this.store.getState().favorite && !_isFav) {
                        setTimeout(() => this.favCall(_id, true), 200);
                    }
                }
            }); 
        })
        .catch( (error) => {
            if (error.response?.statusText === "Unauthorized") {
                window.GNBLogin();
            }
            if (error.response?.data?.result?.error === "EXCEEDED") {
                window.alert(l10n['common.favoritesUpto500']);
            }
            console.log('err---', error.response.data.result.error);
        })
        .then( (d) => {} );
    }

    fav(_newVal){
        if (_newVal.id === this.itemId) {
            this.isFavorite = _newVal.isFavorite;
            this.itemEl.find('.btn-favorite').toggleClass('is-active', this.isFavorite);
        }
    }

} // end of class